var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":"一覧に戻る","placement":"top","effect":"light"}},[_c('BaseButton',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"detail-header-back",attrs:{"icon":"fas fa-arrow-left"},on:{"click":_vm.backPage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }